import { TObjectList } from 'src/api/directory/types';

import { isObjectWithKeys } from './is-object-with-keys';

export const checkIsJoinResponseDirectory = (directory: unknown): directory is TObjectList => {
  if (!isObjectWithKeys(directory)) {
    return false;
  }

  if (Object.values(directory).some((dir) => !isObjectWithKeys(dir))) {
    return false;
  }

  return true;
};
